<template>
  <teleport to="body">
    <div v-if="show" class="">

      <!-- Overlay -->
      <div class="fixed inset-0 z-100 bg-primary-0 bg-opacity-50 backdrop-blur-sm transition-opacity duration-300"
           @click="overlayClick"
      >
      </div>

      <div
          class="fixed top-0  flex justify-center  items-center p-5 z-120 left-0 w-screen h-screen  transform transition-transform duration-300 ease-in-out">

        <div class="bg-white  p-5 rounded-lg" :class="[props.width]">

          <div class="flex items-center border-b justify-between">
            <slot name="title"/>
            <font-awesome-icon @click="show=false" :icon="['fas','times']" class="text-black text-lg"/>
          </div>
          <div class="">
            <slot name="content"/>
          </div>
          <div class="">
            <slot name="footer"/>
          </div>

        </div>

      </div>
    </div>
  </teleport>
</template>

<script setup>

const props = defineProps({
  modelValue: Boolean,
  closeOnClickOutside: {
    type: Boolean,
    default: true
  },
  width: {
    type: String,
    default: 'w-[320px]'
  }
})

const show = defineModel()

const overlayClick = () => {
  if (!props.closeOnClickOutside) return
  show.value = false
}
</script>